(function () {
  function isAigWarrantySearchResult(item) {
    if (!item) return false;
    var ids = ['8392799551603', '8392800436339', '8392800665715', '8392800796787'];
    var skus = ['1342842250', '1342847649', '1342842221', '1342842216'];
    var handles = [3, 5, 10, 12].map(function (term) {
      return 'agi-warranty-' + term + '-years-for-bravo-single-zone-products';
    });
    var id = String(item.id || item.product_id || '').split('/').pop();
    var handle = String(item.handle || '').toLowerCase();
    if (!handle && item.url) {
      try {
        handle = new URL(item.url, window.location.origin).pathname.split('/products/')[1] || '';
        handle = handle.split('/')[0].toLowerCase();
      } catch (error) {}
    }
    if (ids.indexOf(id) !== -1 || handles.indexOf(handle) !== -1) return true;
    if (skus.indexOf(String(item.sku || '')) !== -1) return true;
    if (Array.isArray(item.variants) && item.variants.some(function (variant) {
      return skus.indexOf(String(variant.sku || '')) !== -1;
    })) return true;
    var title = String(item.title || item.text || item.query || '').trim();
    return skus.indexOf(title) !== -1 || (/\b(?:aig|agi)\b/i.test(title) && /\bwarrant(?:y|ies)\b/i.test(title));
  }

  function init(header) {
    if (!header || header.dataset.smsHeaderReady === 'true') return;
    header.dataset.smsHeaderReady = 'true';

    var nav = header.querySelector('[data-sms-nav]');
    var mobileToggle = header.querySelector('[data-sms-mobile-toggle]');
    var megaToggle = header.querySelector('[data-sms-mega-toggle]');
    var mega = header.querySelector('[data-sms-mega]');
    var dropdownToggles = Array.prototype.slice.call(header.querySelectorAll('[data-sms-dropdown-toggle]'));
    var dropdownPanels = Array.prototype.slice.call(header.querySelectorAll('[data-sms-dropdown-panel]'));
    var dropdownWraps = Array.prototype.slice.call(header.querySelectorAll('[data-sms-dropdown-wrap]'));
    var departmentButtons = Array.prototype.slice.call(header.querySelectorAll('[data-sms-department-button]'));
    var departmentPanels = Array.prototype.slice.call(header.querySelectorAll('[data-sms-department-panel]'));
    var departmentPanelsHome = mega ? mega.querySelector('.smsMegaPanels') : null;
    var desktopQuery = window.matchMedia('(min-width: 901px)');
    var closeTimer;

    function syncDepartmentPanelPlacement() {
      if (!departmentPanelsHome || !departmentButtons.length || !departmentPanels.length) return;

      if (desktopQuery.matches) {
        departmentPanels.forEach(function (panel) {
          departmentPanelsHome.appendChild(panel);
        });
        return;
      }

      departmentPanels.forEach(function (panel) {
        var active = panel.classList.contains('is-active');
        var button = departmentButtons.filter(function (candidate) {
          return candidate.dataset.smsDepartment === panel.dataset.smsDepartmentPanel;
        })[0];

        if (active && button && button.parentNode) {
          button.insertAdjacentElement('afterend', panel);
        } else {
          departmentPanelsHome.appendChild(panel);
        }
      });
    }

    function closeDepartment() {
      departmentButtons.forEach(function (button) {
        button.classList.remove('is-active');
        button.setAttribute('aria-selected', 'false');
      });
      departmentPanels.forEach(function (panel) {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });
      syncDepartmentPanelPlacement();
    }

    function setDepartment(id) {
      departmentButtons.forEach(function (button) {
        var active = button.dataset.smsDepartment === id;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      departmentPanels.forEach(function (panel) {
        var active = panel.dataset.smsDepartmentPanel === id;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      syncDepartmentPanelPlacement();
    }

    function closeDropdowns(exceptName) {
      dropdownToggles.forEach(function (button) {
        var keepOpen = exceptName && button.dataset.smsDropdownToggle === exceptName;
        button.setAttribute('aria-expanded', keepOpen ? 'true' : 'false');
      });
      dropdownPanels.forEach(function (panel) {
        var keepOpen = exceptName && panel.dataset.smsDropdownPanel === exceptName;
        panel.classList.toggle('is-open', Boolean(keepOpen));
      });
    }

    function setMega(open) {
      if (!mega || !megaToggle) return;
      if (open) closeDropdowns();
      mega.classList.toggle('is-open', open);
      megaToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && departmentButtons.length) {
        var selected = departmentButtons.filter(function (button) {
          return button.classList.contains('is-active');
        })[0];
        setDepartment(selected ? selected.dataset.smsDepartment : departmentButtons[0].dataset.smsDepartment);
      }
    }

    function setDropdown(name, open) {
      if (open) {
        setMega(false);
        closeDropdowns(name);
      } else {
        closeDropdowns();
      }
    }


    function initSmartSearch() {
      var form = header.querySelector('[data-sms-smart-search]');
      if (!form || form.dataset.smsSmartSearchReady === 'true') return;
      form.dataset.smsSmartSearchReady = 'true';

      var input = form.querySelector('[data-sms-smart-search-input]');
      var panel = form.querySelector('[data-sms-smart-search-panel]');
      var list = form.querySelector('[data-sms-smart-search-list]');
      var status = form.querySelector('[data-sms-smart-search-status]');
      if (!input || !panel || !list || !window.fetch || !window.URLSearchParams) return;

      var suggestUrl = form.dataset.smsSmartSearchUrl || '/search/suggest.json';
      var searchUrl = form.getAttribute('action') || '/search';
      var debounceTimer;
      var abortController;
      var activeIndex = -1;
      var optionLinks = [];
      var mobileSearchQuery = window.matchMedia('(max-width: 900px)');
      var searchActivatedByUser = false;

      function markSearchActivation(event) {
        if (event.isTrusted !== false) searchActivatedByUser = true;
      }

      function releaseUnexpectedMobileSearchFocus() {
        input.removeAttribute('autofocus');
        if (!mobileSearchQuery.matches || searchActivatedByUser) return;
        if (document.activeElement === input) input.blur();
      }

      function queueMobileSearchFocusRelease() {
        searchActivatedByUser = false;
        releaseUnexpectedMobileSearchFocus();
        window.requestAnimationFrame(function () {
          releaseUnexpectedMobileSearchFocus();
          window.setTimeout(releaseUnexpectedMobileSearchFocus, 250);
        });
      }

      input.addEventListener('pointerdown', markSearchActivation, { passive: true });
      input.addEventListener('touchstart', markSearchActivation, { passive: true });
      input.addEventListener('mousedown', markSearchActivation, { passive: true });
      input.addEventListener('keydown', markSearchActivation);
      window.addEventListener('pageshow', queueMobileSearchFocusRelease);
      queueMobileSearchFocusRelease();

      function setOpen(open) {
        panel.hidden = !open;
        form.classList.toggle('is-smart-open', open);
        input.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) {
          activeIndex = -1;
          input.removeAttribute('aria-activedescendant');
        }
      }

      function setStatus(message) {
        status.textContent = message || '';
      }

      function clearResults(message) {
        optionLinks = [];
        list.innerHTML = '';
        setStatus(message || '');
        setOpen(Boolean(message));
      }

      function buildSearchUrl(query) {
        return searchUrl + '?q=' + encodeURIComponent(query);
      }

      function normalizeImage(image) {
        if (!image) return '';
        if (typeof image === 'string') return image;
        return image.url || image.src || '';
      }

      function getProductMeta(product) {
        var meta = [];
        if (product.vendor) meta.push(product.vendor);
        if (product.product_type) meta.push(product.product_type);
        if (product.variants && product.variants.length && product.variants[0].sku) meta.push(product.variants[0].sku);
        return meta.filter(Boolean).join(' • ');
      }

      function createTitle(text) {
        var strong = document.createElement('strong');
        strong.textContent = text || '';
        return strong;
      }

      function createSmall(text) {
        var small = document.createElement('small');
        small.textContent = text || '';
        return small;
      }

      function createSectionTitle(text) {
        var title = document.createElement('p');
        title.className = 'smsSmartSearchSectionTitle';
        title.textContent = text;
        list.appendChild(title);
      }

      function createProductItem(product, index) {
        var link = document.createElement('a');
        link.className = 'smsSmartSearchItem smsSmartSearchItem--product';
        link.href = product.url || (product.handle ? '/products/' + product.handle : buildSearchUrl(input.value));
        link.id = input.id + '-suggestion-' + index;
        link.setAttribute('role', 'option');
        link.dataset.smsSmartSearchOption = 'true';

        var thumb = document.createElement('span');
        thumb.className = 'smsSmartSearchThumb';
        var imageUrl = normalizeImage(product.image);
        if (imageUrl) {
          var img = document.createElement('img');
          img.src = imageUrl;
          img.alt = '';
          img.loading = 'lazy';
          thumb.appendChild(img);
        } else {
          var fallback = document.createElement('b');
          fallback.setAttribute('aria-hidden', 'true');
          fallback.textContent = (product.title || '?').trim().charAt(0);
          thumb.appendChild(fallback);
        }

        var copy = document.createElement('span');
        copy.className = 'smsSmartSearchCopy';
        copy.appendChild(createTitle(product.title || 'View product'));
        var meta = getProductMeta(product);
        if (meta) copy.appendChild(createSmall(meta));

        var badge = document.createElement('span');
        badge.className = 'smsSmartSearchBadge';
        badge.textContent = 'Product';

        link.appendChild(thumb);
        link.appendChild(copy);
        link.appendChild(badge);
        return link;
      }

      function createTextItem(item, label, index) {
        var text = item.text || item.title || item.query || label;
        var link = document.createElement('a');
        link.className = 'smsSmartSearchItem smsSmartSearchItem--text';
        link.href = item.url || buildSearchUrl(text);
        link.id = input.id + '-suggestion-' + index;
        link.setAttribute('role', 'option');
        link.dataset.smsSmartSearchOption = 'true';

        var copy = document.createElement('span');
        copy.className = 'smsSmartSearchCopy';
        copy.appendChild(createTitle(text));

        var badge = document.createElement('span');
        badge.className = 'smsSmartSearchBadge';
        badge.textContent = label;

        link.appendChild(copy);
        link.appendChild(badge);
        return link;
      }

      function activate(index) {
        optionLinks.forEach(function (link, optionIndex) {
          link.classList.toggle('is-active', optionIndex === index);
        });
        activeIndex = index;
        if (optionLinks[index]) {
          input.setAttribute('aria-activedescendant', optionLinks[index].id);
          optionLinks[index].scrollIntoView({ block: 'nearest' });
        } else {
          input.removeAttribute('aria-activedescendant');
        }
      }

      function renderResults(query, data) {
        var results = data && data.resources && data.resources.results ? data.resources.results : {};
        var products = (results.products || []).filter(function (product) { return !isAigWarrantySearchResult(product); }).slice(0, 6);
        var collections = (results.collections || []).slice(0, 3);
        var queries = (results.queries || []).filter(function (queryItem) { return !isAigWarrantySearchResult(queryItem); }).slice(0, 4);

        list.innerHTML = '';
        optionLinks = [];
        setStatus('');

        if (products.length) {
          createSectionTitle('Product matches');
          products.forEach(function (product) {
            optionLinks.push(createProductItem(product, optionLinks.length));
            list.appendChild(optionLinks[optionLinks.length - 1]);
          });
        }

        if (queries.length) {
          createSectionTitle('Suggested searches');
          queries.forEach(function (queryItem) {
            optionLinks.push(createTextItem(queryItem, 'Search', optionLinks.length));
            list.appendChild(optionLinks[optionLinks.length - 1]);
          });
        }

        if (collections.length) {
          createSectionTitle('Collections');
          collections.forEach(function (collection) {
            optionLinks.push(createTextItem(collection, 'Collection', optionLinks.length));
            list.appendChild(optionLinks[optionLinks.length - 1]);
          });
        }

        var viewAll = document.createElement('a');
        viewAll.className = 'smsSmartSearchViewAll';
        viewAll.href = buildSearchUrl(query);
        viewAll.textContent = 'View all results';
        list.appendChild(viewAll);

        if (!optionLinks.length) {
          clearResults('No quick matches yet. Press Enter to search the full store.');
          return;
        }

        setOpen(true);
      }

      function fetchSuggestions(query) {
        if (abortController) abortController.abort();
        abortController = window.AbortController ? new AbortController() : null;

        var params = new URLSearchParams();
        params.set('q', query);
        params.set('resources[type]', 'product,collection,query');
        params.set('resources[limit]', '8');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('resources[options][fields]', 'title,product_type,vendor,variants.title,variants.sku');

        setStatus('Finding matches...');
        setOpen(true);

        fetch(suggestUrl + '?' + params.toString(), {
          credentials: 'same-origin',
          signal: abortController ? abortController.signal : undefined
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Predictive search failed');
            return response.json();
          })
          .then(function (data) {
            renderResults(query, data);
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            clearResults('');
          });
      }

      function queueSearch() {
        var query = input.value.trim();
        window.clearTimeout(debounceTimer);

        if (query.length < 2) {
          if (abortController) abortController.abort();
          clearResults('');
          return;
        }

        debounceTimer = window.setTimeout(function () {
          fetchSuggestions(query);
        }, 180);
      }

      input.addEventListener('focus', function () {
        setMega(false);
        closeDropdowns();
        if (input.value.trim().length >= 2) queueSearch();
      });

      input.addEventListener('input', queueSearch);

      input.addEventListener('keydown', function (event) {
        if (panel.hidden) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          activate(optionLinks.length ? (activeIndex + 1) % optionLinks.length : -1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          activate(optionLinks.length ? (activeIndex <= 0 ? optionLinks.length - 1 : activeIndex - 1) : -1);
        } else if (event.key === 'Enter' && activeIndex > -1 && optionLinks[activeIndex]) {
          event.preventDefault();
          window.location.href = optionLinks[activeIndex].href;
        } else if (event.key === 'Escape') {
          setOpen(false);
        }
      });

      input.addEventListener('blur', function () {
        window.setTimeout(function () {
          if (!form.contains(document.activeElement)) setOpen(false);
        }, 140);
      });

      panel.addEventListener('mousedown', function (event) {
        if (event.target.closest('a')) return;
        event.preventDefault();
      });

      document.addEventListener('click', function (event) {
        if (!form.contains(event.target)) setOpen(false);
      });

      form.addEventListener('submit', function () {
        setOpen(false);
      });
    }

    function setMobileNav(open) {
      if (!nav || !mobileToggle) return;
      nav.classList.toggle('is-mobile-open', open);
      mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      mobileToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      if (!open) {
        setMega(false);
        closeDropdowns();
      }
    }

    departmentButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!desktopQuery.matches && button.classList.contains('is-active')) {
          closeDepartment();
          return;
        }
        setDepartment(button.dataset.smsDepartment);
      });
      button.addEventListener('mouseenter', function () {
        if (desktopQuery.matches) setDepartment(button.dataset.smsDepartment);
      });
      button.addEventListener('focus', function () {
        if (desktopQuery.matches) setDepartment(button.dataset.smsDepartment);
      });
    });

    if (megaToggle) {
      megaToggle.addEventListener('click', function () {
        setMega(!mega.classList.contains('is-open'));
      });
      megaToggle.addEventListener('mouseenter', function () {
        if (!desktopQuery.matches) return;
        window.clearTimeout(closeTimer);
        setMega(true);
      });
      megaToggle.addEventListener('mouseleave', function () {
        if (!desktopQuery.matches) return;
        closeTimer = window.setTimeout(function () {
          setMega(false);
        }, 180);
      });
    }

    if (mega) {
      mega.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
      });
      mega.addEventListener('mouseleave', function () {
        if (!desktopQuery.matches) return;
        closeTimer = window.setTimeout(function () {
          setMega(false);
        }, 180);
      });
    }

    dropdownToggles.forEach(function (button) {
      button.addEventListener('click', function () {
        setDropdown(button.dataset.smsDropdownToggle, button.getAttribute('aria-expanded') !== 'true');
      });
      button.addEventListener('focus', function () {
        if (desktopQuery.matches) setDropdown(button.dataset.smsDropdownToggle, true);
      });
    });

    dropdownWraps.forEach(function (wrap) {
      var button = wrap.querySelector('[data-sms-dropdown-toggle]');
      if (!button) return;
      wrap.addEventListener('mouseenter', function () {
        if (!desktopQuery.matches) return;
        window.clearTimeout(closeTimer);
        setDropdown(button.dataset.smsDropdownToggle, true);
      });
      wrap.addEventListener('mouseleave', function () {
        if (!desktopQuery.matches) return;
        closeTimer = window.setTimeout(function () {
          setDropdown(button.dataset.smsDropdownToggle, false);
        }, 180);
      });
    });

    if (mobileToggle) {
      mobileToggle.addEventListener('click', function () {
        setMobileNav(!nav.classList.contains('is-mobile-open'));
      });
    }

    header.querySelectorAll('.smsNavLink, .smsUtilityLink, .smsNavDropdownLink, .smsNavBrandCard, .smsNavDropdownAll').forEach(function (link) {
      link.addEventListener('click', function () {
        closeDropdowns();
        if (!desktopQuery.matches) setMobileNav(false);
      });
    });

    document.addEventListener('click', function (event) {
      if (!header.contains(event.target)) {
        setMega(false);
        closeDropdowns();
        if (!desktopQuery.matches) setMobileNav(false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        var activeTrigger = header.querySelector('[aria-expanded="true"][data-sms-mega-toggle], [aria-expanded="true"][data-sms-dropdown-toggle]');
        setMega(false);
        closeDropdowns();
        setMobileNav(false);
        if (activeTrigger) activeTrigger.focus();
      }
    });

    desktopQuery.addEventListener('change', function (event) {
      if (event.matches) setMobileNav(false);
      syncDepartmentPanelPlacement();
    });

    syncDepartmentPanelPlacement();

    initSmartSearch();

    var toast = header.querySelector('[data-sms-header-toast-output]');
    var toastTimer;
    header.querySelectorAll('[data-sms-header-toast]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!toast) return;
        toast.textContent = button.dataset.smsHeaderToast;
        toast.classList.add('is-visible');
        window.clearTimeout(toastTimer);
        toastTimer = window.setTimeout(function () {
          toast.classList.remove('is-visible');
        }, 2500);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sms-header]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
}());
